export default {
  dashboard: 'dashboard',
  login: 'login',
  logout: 'logout',
  accountExists: 'accountExists',
  signUp: 'signUp',
  signUpVerification: 'signUpVerification',
  resetPassword: 'resetPassword',
  resetPasswordConfirmation: 'resetPasswordConfirmation',
  termsAndConditions: 'termsAndConditions',
  privacyPolicy: 'privacyPolicy',
  novatedCalculatorAssumptions: 'novatedCalculatorAssumptions',
  documentSigned: 'documentSigned',
  nonLoginCalculator: 'nonLoginCalculator',
  hrApprovals: 'hrApprovals',
  hrApproval: 'hrApproval',
  claims: 'claims',
  claimsLanding: 'claimsLanding',
  claimsEvNew: 'claimsEvNew',
  claimsNew: 'claimsNew',
  budgets: 'budgets',
  budgetDetail: 'budgetDetail',
  lease: 'lease'
};
